/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  PostUsersResetPasswordVerifyMutationRequest,
  PostUsersResetPasswordVerifyMutationResponse,
  PostUsersResetPasswordVerify400,
} from '../entities/PostUsersResetPasswordVerify'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { postUsersResetPasswordVerify } from '../api/postUsersResetPasswordVerify'
import { useMutation } from '@tanstack/react-query'

export const postUsersResetPasswordVerifyMutationKey = () => [{ url: '/users/reset-password/verify' }] as const

export type PostUsersResetPasswordVerifyMutationKey = ReturnType<typeof postUsersResetPasswordVerifyMutationKey>

/**
 * @description Подтверждение восстановления пароля
 * @summary Подтверждение восстановления пароля
 * {@link /users/reset-password/verify}
 */
export function usePostUsersResetPasswordVerify<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostUsersResetPasswordVerifyMutationResponse,
      ResponseErrorConfig<PostUsersResetPasswordVerify400>,
      { data: PostUsersResetPasswordVerifyMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<PostUsersResetPasswordVerifyMutationRequest>> & { client?: typeof client }
  } = {},
) {
  const { mutation: { client: queryClient, ...mutationOptions } = {}, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? postUsersResetPasswordVerifyMutationKey()

  return useMutation<
    PostUsersResetPasswordVerifyMutationResponse,
    ResponseErrorConfig<PostUsersResetPasswordVerify400>,
    { data: PostUsersResetPasswordVerifyMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postUsersResetPasswordVerify(data, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}